<template>
  <div>
    <el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="周期性报价" name="periodicQuotation" lazy>
          <V-PeriodicQuotation ref="periodicQuotation">
          </V-PeriodicQuotation>
        </el-tab-pane>
        <el-tab-pane label="竞价报价" name="compareList" lazy>
          <V-CompareList ref="compareList">
          </V-CompareList>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import VPeriodicQuotation from './periodicQuotation';
import VCompareList from './compareList';

export default {
  data() {
    return {
      activeName: 'periodicQuotation',
      tabActiveName: sessionStorage.getItem('quoteTabActiveName'),
      active: ['periodicQuotation', 'compareList'],
      isShow: false,
    };
  },
  components: {
    VPeriodicQuotation,
    VCompareList,
  },
  created() {
    this.tabActive();
  },
  mounted() {
    this.handleClick();
  },
  computed: {
  },
  methods: {
    handleClick(tab, event) {
      sessionStorage.setItem('quoteTabActiveName', this.activeName);
    },
    tabActive() {
      const flag = this.active.find((item) => {
        if (this.tabActiveName == item) {
          return true;
        }
      });
      if (flag) {
        this.activeName = this.tabActiveName;
      }
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/quote.vue